module.exports = __webpack_public_path__ + "img/jyln@2X.de8c4da7.png";